<template>
    <div>
        <header-page></header-page>
        <full-page :options="options" id="fullpage">
            <div class="section" id="section0">
                <div class="slide" id="mariage">
                </div>
            </div>
            <div class="TitleBottom"><a
                    @click="$vuetify.goTo('#welcome',{ duration:1000, offset:0, easing:'easeInOutCubic'})">
                <h1>
                    <v-icon :size="screenwidth" color="white">mdi-chevron-down</v-icon>
                    Le traiteur des mariages réussis
                </h1>
            </a></div>
        </full-page>
        <div>
            <div class="backgroundGreen" id="welcome">
                <div class="media-row">
                    <div class="row backgroundGreen">
                        <div class="col-12 col-md-8 col-lg-8" style="background:#c96386;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h2 class="display-5 bottomH2">Un repas d’exception pour le plus beau jour de
                                            votre vie</h2>
                                        <p>
                                            Chez Croustillance, nous savons que vous attendez beaucoup de cette journée
                                            à l’image de votre amour.
                                        </p>
                                        <p>
                                            Voilà pourquoi nous vous accompagnons pour l’organiser au mieux, et
                                            confectionner un <b>repas de mariage à la hauteur de vos rêves.</b>
                                        </p>
                                        <p>Pour vous satisfaire, vous et vos convives, nous proposons un large choix de
                                            formules : cocktail personnalisé pour le vin d’honneur, grazing tables,
                                            buffet chaud ou froid, repas assis ou animations culinaires.</p>
                                        <p>Toutes nos prestations se déclinent sur mesure, pour une partition unique
                                            adaptée à vos envies, au budget et au thème retenu.</p>
                                        <p>Vous voulez offrir à votre <b>réception de mariage</b> un cadre insolite ou
                                            hors-norme ? Nos cuisiniers et nos serveurs sont des magiciens !
                                            Avertissez-nous : nous savons officier partout, même dans les lieux les plus
                                            exceptionnels...</p>
                                        <h3 class="display-1 bottomH2">5 bonnes raisons de nous faire confiance </h3>
                                        <p class="pAlpha">
                                        <ul>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                Notre
                                                <router-link :to="{ name: 'equipe'}"
                                                             class="LinkText">chef Frédéric
                                                </router-link>
                                                , derrière le piano depuis plus de 30 ans, s’est
                                                exercé au contact des plus grands avant de choisir de s’installer en
                                                Lorraine, à proximité de Châtel.
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                Grâce à cette longue expérience, nous travaillons main dans la main avec
                                                tous les autres partenaires sélectionnés. Souvent, nous les connaissons
                                                déjà !

                                            </li>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                Nous ne cuisinons que des matières premières de grande qualité :
                                                ingrédients frais, produits exotiques ou
                                                <router-link :to="{ name: 'vosgesTerroir'}"
                                                             class="LinkText">labellisés Vosges Terroir
                                                </router-link>
                                                .
                                            </li>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                Vous êtes invités à une dégustation des plats pressentis, pour vérifier
                                                par vous-même la qualité de nos repas et affiner vos choix.
                                            </li>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                De nombreux mariés lorrains nous recommandent ! Lisez <a
                                                    href="https://www.facebook.com/pg/croustillance/reviews/?ref=page_internal"
                                                    target="_blank" class="LinkText">ici leurs
                                                témoignages enthousiastes</a>.

                                            </li>
                                        </ul>
                                        </p>


                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-image: url('img/mariage/piece-montee.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                            <div class="item media text-white alignLeft">

                            </div>
                        </div>
                    </div>
                </div>
                <div class="media-row">
                    <div class="row backgroundGreen">
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-color:#564740;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h3 class="display-6">Un cocktail de mariage personnalisé</h3>
                                        <p>
                                            Pour un apéritif raffiné et gourmand, optez pour notre sélection de bouchées
                                            salées :</p>
                                        <p  class="pAlpha">
                                        <ul>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                en-cas délicats
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                cuillères et verrines

                                            </li>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                gougères et tartelettes
                                            </li>
                                        </ul>
                                        </p>
                                        <div class="btns-action sr-up-td3 text-primary">
                                            <a href="pdf/cocktail-mariage-sale.pdf" target="_blank"
                                               class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                <span class="text">Découvrir le cocktail de mariage salé</span>
                                            </a>
                                        </div>
                                        <div class="btns-action sr-up-td3 text-primary">
                                            <a href="pdf/cocktail-mariage-sale-et-sucre.pdf" target="_blank"
                                               class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                <span class="text">Découvrir le cocktail de mariage salé & sucré</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-image: url('img/mariage/aperitif-mariage.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                            <div class="item media text-white alignLeft">
                                <div class="media-img">
                                    <div class="mask"></div>
                                    <img class="img-block" src="img/mariage/aperitif-mariage.jpg" alt="Apéritif de mariage"
                                         style="display: none;">
                                    <div class="img"
                                         style="background-image: url('img/mariage/aperitif-mariage.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                                </div>
                                <div class="media-body align-top">
                                    <div class="desc">

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-color:#7d2c6f;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h3 class="display-6">Notre carte spéciale mariages</h3>
                                        <p>
                                            Si vous prévoyez un repas assis après la cérémonie, nous vous suggérons notre
                                            carte spéciale mariages, avec les menus <b>Passion</b> et <b>Fusion</b>.<br>
                                            Nos propositions évoluent bien sûr avec vos attentes et vos envies !
                                        </p>
                                      <div class="btns-action sr-up-td3 text-primary">
                                        <a href="/pdf/carte-mariage-2023.pdf" target="_blank"
                                           class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                          <span class="text">Découvrir la carte spéciale mariage</span>
                                        </a>
                                      </div>
                                        <div class="btns-action sr-up-td3 text-primary">
                                            <a href="/pdf/menu-mariage-passion.pdf" target="_blank"
                                               class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                <span class="text">Exemple de menu PASSION</span>
                                            </a>
                                        </div>
                                        <div class="btns-action sr-up-td3 text-primary">
                                            <a href="/pdf/menu-mariage-fusion.pdf" target="_blank"
                                               class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                <span class="text">Exemple de menu FUSION</span>
                                            </a>
                                        </div><!-- <br>
                                        <h3 class="display-6 titleSpacer" style="background-color: #7d2c6fb3;">Les buffets de mariage</h3>
                                        <div class="btns-action sr-up-td3 text-primary">
                                            <a href="pdf/buffet-mariage-alliance.pdf" target="_blank"
                                               class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                <span class="text">Découvrir le buffet de mariage ALLIANCE</span>
                                            </a>
                                        </div>
                                        <div class="btns-action sr-up-td3 text-primary">
                                            <a href="pdf/buffet-mariage-union.pdf" target="_blank"
                                               class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                <span class="text">Découvrir le buffet de mariage UNION</span>
                                            </a>
                                        </div>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="media-row">
                    <div class="row backgroundGreen">
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-image: url('img/mariage/mariage-entree-poisson.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                            <div class="item media text-white alignLeft">
                                <div class="media-img">
                                    <div class="mask"></div>
                                    <img class="img-block" src="img/mariage/mariage-entree-poisson.jpg" alt="Les menus de mariage"
                                         style="display: none;">
                                    <div class="img"
                                         style="background-image: url('img/mariage/mariage-entree-poisson.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                                </div>
                                <div class="media-body align-top">
                                    <div class="desc">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-color:#d5b4a8">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h3 class="display-6">Pour les enfants ce jour-là</h3>
                                        <p>
                                            Pour les gourmands jusqu’à 12 ans, Croustillance propose un buffet adapté avec :</p>
                                        <p class="pAlpha">
                                        <ul>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                des légumes doux à croquer
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                des charcuteries variées

                                            </li>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                des fromages à tartiner
                                            </li>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                de bons desserts
                                            </li>
                                        </ul>
                                        </p>
                                        <div class="btns-action sr-up-td3 text-primary">
                                            <a href="pdf/mariage-buffet-enfants.pdf" target="_blank"
                                               class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                <span class="text">Découvrir le buffet des enfants</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-color:#c3797a">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h3 class="display-6">Et le lendemain ?</h3>
                                        <p>
                                            Pour continuer à régaler vos invités restés sur place, notre buffet du lendemain comporte :
                                        </p>
                                        <p class="pAlpha">
                                        <ul>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                de délicieux sandwichs
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                des réductions salées

                                            </li>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                des mignardises sucrées
                                            </li>
                                        </ul>
                                        </p>
                                        <div class="btns-action sr-up-td3 text-primary">
                                            <a href="/pdf/mariage-buffet-lendemain.pdf" target="_blank"
                                               class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                <span class="text">Découvrir le buffet du lendemain</span>
                                            </a>
                                        </div>
                                      <div class="btns-action sr-up-td3 text-primary">
                                        <a href="/pdf/cocktail-mariage-2023.pdf" target="_blank"
                                           class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                          <span class="text">Découvrir le cocktail du lendemain</span>
                                        </a>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="media-row">
                    <div class="row backgroundGreen">
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-image: url('img/mariage/choux.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                            <div class="item media text-white alignLeft">
                                <div class="media-img">
                                    <div class="mask"></div>
                                    <img class="img-block" src="img/mariage/choux.jpg" alt="Pour un mariage réussi"
                                         style="display: none;">
                                    <div class="img"
                                         style="background-image: url('img/mariage/choux.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                                </div>
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h3 class="display-6">Des desserts inoubliables</h3>
                                        <p class="pSpacer" style="background-color: #2c2e4f6b">
                                            Nous pouvons prévoir des desserts personnalisés, en harmonie avec le décor ou
                                            le thème choisi par les mariés.<br>
                                            Pour une pièce montée ou un wedding cake unique, consultez-nous.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-image: url('img/mariage/salle-mariage.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                            <div class="item media text-white alignLeft">
                                <div class="media-img">
                                    <div class="mask"></div>
                                    <img class="img-block" src="img/mariage/salle-mariage.jpg" alt="Salle de mariage"
                                         style="display: none;">
                                    <div class="img"
                                         style="background-image: url('img/mariage/salle-mariage.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                                </div>
                                <div class="media-body align-top">
                                    <div class="desc">

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-color:#b88ca3;">
                            <div class="item media text-white alignLeft">

                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h3 class="display-6">Les options pour la réception</h3>
                                        <p>
                                            Croustillance peut prendre en charge le jour de votre mariage :</p>
                                        <p class="pAlpha">
                                        <ul>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                les boissons, alcoolisées ou non
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                la location de la vaisselle

                                            </li>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                le nappage et le dressage des tables
                                            </li>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                le service en salle
                                            </li>
                                        </ul>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer-page> </footer-page>
    </div>

</template>

<script>
    import HeaderPage from './headerPage'
    import FooterPage from './footerPage'

    export default {
        name: 'mariage',
        components: {
            HeaderPage,
            FooterPage
        },
        data() {
            return {
                options: {
                    licenseKey: 'A32C7F42-F0FE4A04-AAB7E182-AB1F9C8B',
                    navigation: false,
                    scrollBar: true,
                    autoScrolling: false,
                    fitToSection: false
                }
            }
        },
        methods: {
            afterLoad() {
                console.log('After load')
            },
        },
        computed: {
            screenwidth() {
                if (screen.width > 400) {
                    return 70
                } else {
                    return 30
                }
            }
        },
    created() {
        document.getElementsByTagName('meta')["description"].content = "Le traiteur Croustillance vous accompagne pour un repas de mariage à la hauteur de vos rêves : cocktail, buffet, carte spéciale mariage, pièce montée, wedding cake, etc";
        document.title = "Croustillance, traiteur des mariages réussis | Vosges, Lorraine";
    }
    }
</script>

<style>
    #mariage {
        background: url('/img/mariage/traiteur-mariage.jpg') no-repeat center center;
        padding: 0 0 0 0;
        background-size: cover;
    }
</style>